import icons from 'assets/icons';
import { ROOT_ROUTE } from 'components/constants';
import React from 'react';
import { LinkWithQuery } from '../LinkWithQuery';
import styles from './styles.module.scss';

type Props = {
  full?: boolean;
  compact?: boolean;
};

function MobileLogo({ full = false, compact = false }: Props) {
  const className = [
    styles.mobileLogo,
    full ? styles.expandableMobileLogo : '',
    compact ? styles.compactMobileLogo : '',
    'absolute top-0 z-50',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <LinkWithQuery to={ROOT_ROUTE} className={styles.mobileLogoLink}>
        {full ? (
          <>
            <img className={styles.mobileLogoFull} src={icons.storycardsLogo} title="Storycards" alt="Storycards" />
            <img
              aria-hidden="true"
              className={styles.mobileLogoMark}
              src={icons.storycardsLogoNoText}
              alt=""
            />
          </>
        ) : (
          <img
            className={styles.mobileLogoMark}
            src={icons.storycardsLogoNoText}
            title="Storycards"
            alt="Storycards"
          />
        )}
      </LinkWithQuery>
    </div>
  );
}

export default MobileLogo;
